import React, { useState } from 'react'

import cogniLogo from '../../images/cogni_logo.png'
import LoginImage from '../../images/login_img.png'
import axios from 'axios'
import { ErrorCross, PasswordEyeOpen, PasswordEyeClose } from '../common/icons'
import '../../App.css'
import { Loader } from '../common/loader/loader'
import {
    EmailICon,
    ErrorIcon,
    PasswordIcons,
} from '../direct_signup/signup-page-icons'
import {
    CancelButton,
    DropdownWrapper,
    ErrorMessage,
    Input,
    InputContainer,
    InputErrorIcon,
    InputWrapper,
    InputContent,
} from '../direct_signup/signup-styled-components'

const errorMessages = {
    0: 'Email is invalid.',
    1: 'Email or password is incorrect',
    2: 'Something Went Wrong',
}

const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const validEmail = email => EmailRegex.test(email)

const onSubmit = (
    email,
    password,
    setEmailAsInvalid,
    setPasswordAsInvalid,
    enableSubmit,
    setLoading
) => e => {
    e.preventDefault()
    if (!validEmail(email)) {
        setEmailAsInvalid({ status: true, msg: errorMessages[0] })
    } else {
        enableSubmit(false)
        setLoading(true)
        axios
            .post(process.env.REACT_APP_AUTH_LOGIN_URL || '/login', {
                email,
                password,
            })
            .then(
                loggIn => {
                    const url = process.env.REACT_APP_AUTH_REDIRECT
                    window.location = url ? url : '/'
                },
                err => {
                    setEmailAsInvalid({ status: true, msg: errorMessages[1] })
                    setPasswordAsInvalid(true)
                    enableSubmit(true)
                    setLoading(false)
                }
            )
    }
    return false
}

const resetErrors = (setEmailAsInvalid, setPasswordAsInvalid) => () => {
    setEmailAsInvalid && setEmailAsInvalid({ status: false })
    setPasswordAsInvalid(false)
}

const handleEmailChange = setEmail => e => setEmail(e.target.value)
const handlePasswordChange = setPassword => e => setPassword(e.target.value)

const handleInvalidEmail = setEmailIsInvalid => e => {
    if (EmailRegex.test(e.target.value) === false) {
        e.preventDefault()
        setEmailIsInvalid({ status: true, msg: errorMessages[0] })
        // return false;
    }
}

const PasswordEye = ({ toggle, open }) => {
    return open ? (
        <PasswordEyeOpen toggle={toggle} />
    ) : (
        <PasswordEyeClose toggle={toggle} />
    )
}

const Login = props => {
    const [showLoading, setLoading] = useState(false)

    return (
        <Wrapper>
            {/* <Header /> */}
            <ContentWrapper showHeaderTitle={!showLoading}>
                <LoginForm
                    {...props}
                    setLoading={setLoading}
                    loading={showLoading}
                />
            </ContentWrapper>
        </Wrapper>
    )
}

function Wrapper(props) {
    return (
        <div className="login_bg_height login">
            <div className="login_bg_width">
                <div className="login_bg_width_left">
                    <h2>
                        Welcome back to <span>Workativ Assistant</span>
                    </h2>
                    <p>Log In to continue to your account</p>
                </div>
                <div className="row justify-content-center">{props.children}</div>
            </div>
        </div>
    )
}

function Header() {
    return (
        <div className="col-md-6 col-lg-6 login_bg_width_left">
            <img
                className="centerImage"
                src={cogniLogo}
                alt="Assistant"
                title="Assistant"
            />
            <h2>
                Welcome back to <span>Workativ Assistant</span>
            </h2>
            <p>Log In to continue to your account</p>
            <div className="left_bottom_img">
                <img
                    src={LoginImage}
                    align="middle"
                    alt="Login_img"
                    title="Login_img"
                />
            </div>
        </div>
    )
}

function ContentWrapper(props) {
    return (
        <div className="login_bg_width_left_right">
            {props.showHeaderTitle && (
                <h3>
                    <span>Log In</span>
                </h3>
            )}
            <div className="login_bg_width_left_right_form">
                {props.children}
            </div>
        </div>
    )
}

function LoginForm(props) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isInvalidEmail, setIsEmailInvalid] = useState({
        status: false,
        msg: errorMessages[0],
    })
    const [isInvalidPassword, setIsInvalidPassword] = useState(false)
    const [showPassword, setPasswordShow] = useState(false)
    const [submitEnabled, enableSubmit] = useState(true)

    if (props.loading) return <Loader.PopupLoader show={true} />

    return (
        <form
            onSubmit={
                submitEnabled
                    ? onSubmit(
                        email,
                        password,
                        setIsEmailInvalid,
                        setIsInvalidPassword,
                        enableSubmit,
                        props.setLoading
                    )
                    : e => e.preventDefault()
            }
        >
            <EmailField
                setIsEmailInvalid={setIsEmailInvalid}
                setIsInvalidPassword={setIsInvalidPassword}
                isInvalidEmail={isInvalidEmail}
                email={email}
                setEmail={setEmail}
            />

            <PasswordField
                showPassword={showPassword}
                email={email}
                isInvalidPassword={isInvalidPassword}
                password={password}
                setPassword={setPassword}
                setIsEmailInvalid={setIsEmailInvalid}
                setIsInvalidPassword={setIsInvalidPassword}
                setPasswordShow={setPasswordShow}
            />

            <SubmitButton submitEnabled={submitEnabled} {...props} />
            <p className="content_p">
                By signing in, you accept our{' '}
                <a href="https://workativ.com/terms"> Terms</a> and{' '}
                <a href="https://workativ.com/privacy"> Privacy Policy</a>.
            </p>
            <BottomBar {...props} />
        </form>
    )
}

function EmailField(props) {
    const {
        setIsEmailInvalid,
        setIsInvalidPassword,
        isInvalidEmail,
        email,
        setEmail,
    } = props

    return (
        // <div className={isInvalidEmail.status ? 'form-group_error' : ''}>
        /* <label htmlFor="email">User ID</label>
            {isInvalidEmail.status ? <span>{isInvalidEmail.msg}</span> : null}
            <input
                type="text"
                onBlur={e => handleInvalidEmail(setIsEmailInvalid)(e)}
                className="form-control"
                id="email"
                value={email}
                placeholder="Enter your email id..."
                onChange={handleEmailChange(setEmail)}
                onInput={resetErrors(setIsEmailInvalid, setIsInvalidPassword)}
            />
            {isInvalidEmail.status ? (
                <ErrorCross onClick={() => setEmail('')} />
            ) : null} */

        <DropdownWrapper>
            <InputContainer>
                <InputWrapper>
                    <Input
                        primary
                        type="text"
                        onBlur={e => handleInvalidEmail(setIsEmailInvalid)(e)}
                        id="email"
                        value={email}
                        onChange={handleEmailChange(setEmail)}
                        onInput={resetErrors(
                            setIsEmailInvalid,
                            setIsInvalidPassword
                        )}
                    />
                    <InputContent primary>Login Email</InputContent>
                    <CancelButton>
                        <EmailICon />
                    </CancelButton>

                    <>
                        {isInvalidEmail.status && (
                            <>
                                <InputErrorIcon style={{ right: 24 }}>
                                    <ErrorIcon />
                                </InputErrorIcon>
                                <ErrorMessage>
                                    {isInvalidEmail.msg}
                                </ErrorMessage>
                            </>
                        )}
                    </>
                </InputWrapper>
            </InputContainer>
        </DropdownWrapper>
        // </div>
    )
}

function PasswordField(props) {
    const {
        showPassword,
        email,
        isInvalidPassword,
        password,
        setPassword,
        setIsEmailInvalid,
        setIsInvalidPassword,
        setPasswordShow,
    } = props

    return (
        <div
            className={
                isInvalidPassword
                    ? 'form-group-error-pwd'
                    : 'form-group-hide-pwd'
            }
        >
            <DropdownWrapper>
                <InputContainer>
                    <InputWrapper>
                        <Input
                            primary
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            id="password"
                            onChange={handlePasswordChange(setPassword)}
                            onInput={resetErrors(
                                EmailRegex.test(email) && setIsEmailInvalid,
                                setIsInvalidPassword
                            )}
                        />
                        <InputContent primary>Password</InputContent>
                        <CancelButton>
                            <PasswordIcons />
                        </CancelButton>

                        <span
                            className={
                                isInvalidPassword
                                    ? 'passwordeye_login_error'
                                    : null
                            }
                        >
                            <PasswordEye
                                toggle={() => setPasswordShow(!showPassword)}
                                open={showPassword}
                            />
                        </span>
                    </InputWrapper>
                </InputContainer>
            </DropdownWrapper>

            {isInvalidPassword ? (
                <ErrorCross onClick={() => setPassword('')} />
            ) : null}
        </div>
    )
}

function SubmitButton(props) {
    const { submitEnabled } = props

    return (
        <React.Fragment>
            <div className="form-group form-check">
                {/* <label class="form-check-label">
                           <input className="form-check-input" type="checkbox"/> Remember me
                           </label> */}
                <h6
                    onClick={() =>
                        props.history.push(
                            process.env.REACT_APP_UI_BASE_URL +
                            process.env.REACT_APP_UI_FORGOT_PASSWORD_URL
                        )
                    }
                >
                    Forgot Password?
                </h6>
            </div>
            <div className="form-group form-check" />

            <button
                type="submit"
                className="btn btn-primary"
                disabled={!submitEnabled}
            >
                Login
            </button>
        </React.Fragment>
    )
}

function BottomBar(props) {
    return (
        <div className="_g0login_account">
            <div className="_g0login_account_left">
                <h5>Don't have an account?</h5>
            </div>
            <div className="_g0login_account_right">
                <h5>
                    Go to{' '}
                    <span
                        onClick={() =>
                            props.history.push(
                                process.env.REACT_APP_UI_BASE_URL +
                                process.env.REACT_APP_UI_DIRECT_SIGNUP
                            )
                        }
                    >
                        Sign Up
                    </span>
                </h5>
            </div>
        </div>
    )
}

export default Login
